import { styled, Button, Card, Text } from '@/theme/index';

export interface GenericCtaCardProps {
  /** The url for the image to be used as the graphic */
  imgUrl: string;
  /** The title for the feature, most likely. */
  headerText: string;
  /** A basic description of the feature. */
  bodyText: string;
  /** The CTA displayed in the button. */
  buttonText?: string;
  /** Callback fired when the user clicks the button. */
  onCtaClick?: () => void;
  dataCy?: string;
}

const SubmitButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  left: '0',
  right: '0',
  margin: 'auto',
  width: '80%',
}));

/**
 * This component acts as a link to a certain feature/page, and gives basic info about the feature
 */
export function GenericCtaCard({
  imgUrl,
  headerText,
  bodyText,
  buttonText,
  onCtaClick,
  dataCy = 'generic_cta_card',
}: GenericCtaCardProps) {
  return (
    <Card
      variant="outlined"
      className="hover-shadow"
      sx={{ position: 'relative', textAlign: 'center', height: '100%' }}
      data-cy={dataCy}
    >
      <img src={imgUrl} alt="Money" style={{ height: '60px', width: '60px' }} />
      <Text variant="h2" mb="10px">
        {headerText}
      </Text>
      <Text
        variant="body2"
        sx={(theme) => ({
          marginBottom: buttonText ? theme.spacing(7.5) : theme.spacing(1),
        })}
      >
        {bodyText}
      </Text>
      {buttonText && onCtaClick && (
        <SubmitButton
          fullWidth
          variant="contained"
          color="success"
          onClick={onCtaClick}
          data-cy={`${dataCy}_btn`}
        >
          {buttonText}
        </SubmitButton>
      )}
    </Card>
  );
}
